module.exports = __webpack_public_path__ + "static/media/fa-regular-400.1dcb94db.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/fa-regular-400.woff
// module id = 770
// module chunks = 0